import { Component, Input, OnInit } from '@angular/core';
import { ShowBasketButtonType } from 'src/app/modules/general/models/show-basket-button-type';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';
import { Order } from 'src/app/modules/order/models/order';
import { OrderLine } from 'src/app/modules/order/models/order-line';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shop-order',
  templateUrl: './shop-order.component.html',
  styleUrls: ['./shop-order.component.css']
})
export class ShopOrderComponent implements OnInit {

  @Input()
  order: Order;

  constructor(
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit(): void {
  }

  get orderLines(): OrderLine[] {
    return this.order?.orderLines;
  }

  onRemoveLine(orderLine: OrderLine): void {
    if (this.order) {
      this.order.deleteOrderLine(orderLine);
    }
  }

  get totalAmount(): number {
    return this.order.totalAmount;
  }

  get totalTax(): number {
    return this.order.totalTax;
  }

  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }

  get canRemoveLine(): boolean {
    return this.orderLines?.length > 1 ||
      this.shopSettingsService?.shopSettings?.showBasketButtonType !== ShowBasketButtonType.None;
  }
}
